import React, { useEffect } from "react";
import { useWindowWidth } from "@thrivetribe/mvf.hooks.use-window-width";

interface HeaderHamburgerMenuProps {
  isSidebarOpen: boolean;
  setIsSidebarOpen: (x: boolean) => void;
}

export const HeaderHamburgerMenu: React.FC<HeaderHamburgerMenuProps> = ({
  isSidebarOpen,
  setIsSidebarOpen,
}: HeaderHamburgerMenuProps) => {
  const windowWidth = useWindowWidth();

  useEffect(() => {
    if (windowWidth < 1200) {
      setIsSidebarOpen(false);
    } else {
      setIsSidebarOpen(true);
    }
  }, [windowWidth]);

  return (
    <>
      {windowWidth < 1200 && (
        <div
          className={`header__burger-wrapper${
            isSidebarOpen ? " header__burger-wrapper--active" : ""
          }`}
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        >
          <div
            className={`header__burger${
              isSidebarOpen ? " header__burger--active" : ""
            }`}
          ></div>
        </div>
      )}
    </>
  );
};
